import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip, Typography } from '@mui/material';
import EscoDataGrid from '../../Controls/EscoGrid/EscoDataGrid';
import LeyendaView from './LeyendaView';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../Context/AuthContext';
import { getLeyendaList, FrmDelLeyendasSoc } from '../../../Service/leyenda';

export default function LeyendaDataView() {


    const [leyendas, setLeyendas] = useState([]);

    const [loading, setLoading] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);
    const [rowSelectd, setRowSelectd] = useState("Hola");

    //region - "description"

    /*DELETE INICIO*/
    const [showDelete, setShowDelete] = useState(false)

    const closeDeleteDialog = () => {
        setShowDelete(false);
    };

    const ConfirmDelete = () => {
        delFondoImg(rowSelectd);
        setShowDelete(false);
    }

    const delFondoImg = (row) => {

        var frmDelLeyendaSocRequest = {
            CodLeyenda: row.CodLeyenda
        }

        const datos = { frmDelLeyendaSocRequest }

        FrmDelLeyendasSoc(datos, accessToken)
            .then(data => {

                if (data !== undefined && data.Message !== undefined && data.Message.includes("Error")) {

                    init();
                    return;
                } else {
                    init();
                }
            }).catch(
                error => {

                });

    }

    //endregion
    const init = () => {
        console.log('expiration', new Date(tokenExpiration), new Date(Date.now()))
        getAccessToken()
            .then((token) => {
                setLoading(true);
                getLeyendaList(token)
                    .then((data) => {
                        setLeyendas(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false));



            }
            )
    }

    useEffect(() => {
        init();
    }, [])

    const columns = [
        { field: 'DescFrm', headerName: 'Formulario', width: 200 },
        { field: 'DescLey', headerName: 'Descripción', width: 200 },
        {
            field: 'ValorUno', headerName: 'Valor 1', width: 200, flex: 1, autoHeight: true,
            renderCell: (params) => (
                <Tooltip title={params.value} arrow>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {params.value}
                    </div>
                </Tooltip>
            ),
        },
        {
            field: 'ValorDos', headerName: 'Valor 2', width: 200, flex: 1, autoHeight: true,
            renderCell: (params) => (
                <Tooltip title={params.value} arrow>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {params.value}
                    </div>
                </Tooltip>
            ),
        },
        {
            field: 'ValorTres', headerName: 'Valor 3', width: 200, flex: 1, autoHeight: true,
            renderCell: (params) => (
                <Tooltip title={params.value} arrow>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {params.value}
                    </div>
                </Tooltip>
            ),
        },
        { field: 'DescPosicion', headerName: 'Posición', width: 100 },
    ];

    const rows = leyendas

    function getRowId(row) {
        return row.DescLey
    }

    function setData(data) {
        setLeyendas(leyendas.concat({
            DescFrm: data.DescFrm,
            DescLey: data.Descripcion,
            ValorUno: data.ValorUno,
            ValorDos: data.ValorDos,
            ValorTres: data.ValorTres,
            DescPosicion: data.DescPosicion
        }))
    }

    return (
        <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Leyendas</Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={true}
                pEditar={true}
                pSetShowDelete={setShowDelete}
                pSetRowSelectd={setRowSelectd}
            >
                <LeyendaView setData={setData} pInit={init} />
            </EscoDataGrid>
            <Dialog open={showDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Atención"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Desea eliminar el registro?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog}>Cancelar</Button>
                    <Button onClick={ConfirmDelete} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
